import { JurisdictionArea, JAreaAfRowData } from 'data/jurisdictionArea/jurisdictionArea.types';
import { WithAuditDetails, AuditDetails, Operation } from 'data/types';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';

export default function getJurisdictionAreaDataToCreate(
  jurisdictionArea: Partial<JurisdictionArea>,
  originalJurisdictionArea: JurisdictionArea | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  selectedAccessFunction: JAreaAfRowData,
): WithAuditDetails<Partial<JurisdictionArea>> {
  const dataBody = {
    id: jurisdictionArea.SS8ID,
    afid: window.atob(selectedAccessFunction.id)
  }
  const jurisdictionAreaBody: WithAuditDetails<Partial<JurisdictionArea>> = {
    data: dataBody,
  };

  if (isAuditEnabled) {
    const auditDetails = getAuditDetails(
      isAuditEnabled,
      userId,
      userName,
      getAuditFieldInfo(jurisdictionArea, null, false, originalJurisdictionArea),
      '',
      AuditService.CF_GROUP,
      AuditActionType.JURISDICTION_AREA_ADD,
    );
    jurisdictionAreaBody.auditDetails = auditDetails as AuditDetails;
  }

  return jurisdictionAreaBody;
}
